import { createContext } from 'react';

const DepositContext = createContext();

export default DepositContext;
